<template>
  <div class="contrast">

    <div class="contrast-left">
      <div class="title" style="font-weight: 400">
        Contrast
      </div>
      <div class="value">{{value}}</div>
    </div>

    <div class="contrast-right">
      <div class="block">
        <div class="type">Text</div>
        <a-a-level-inline :contrast="value" aa="4.5" aaa="7" />
      </div>
      <div class="block">
        <div class="type">Headlines</div>
        <a-a-level-inline :contrast="value" aa="3" aaa="4.5" />
      </div>
    </div>
    <div style="flex: 1"></div>

    <div class="settings">
      <!-- <img src="../assets/menubar.svg" alt=""> -->
      <!-- <div class="eee">Share</div>
      <div class="eee">Help lines</div>
      <div class="eee">Swatches</div> -->
      <div style="margin-right: 10px" @click="$store.commit('setOsFocus', !osFocus)">
        <span v-if="osFocus">Focus</span>
        <span v-if="!osFocus">Not Focus</span>
      </div>
      <div class="text-button" style="margin-right: 10px">
         <a href = "javascript:void(0)"  data-cb-type = "checkout"  data-cb-plan-id = "app" > S 1 </a>
         <a href = "javascript:void(0)"  data-cb-type = "checkout"  data-cb-plan-id = "color.review-monthly" > S 2 </a>
      </div>
      <div class="text-button" style="margin-right: 10px">
       <a href = "javascript:void(0)"  data-cb-type = "portal" > Manage  </a> 
      </div>
      <div @click="hideApp" class="text-button" style="margin-right: 10px">
        Hide
      </div>
      <div @click="closeApp" class="text-button">
        Close
      </div>
      <div @click="breakApp" class="text-button">
        Break JS
      </div>
    </div>
   
  </div>
</template>

<script>
import AALevelInline from './AALevelInline.vue'

export default {
  components: { AALevelInline },
  computed: {
    value() {
      return Number(this.$store.getters.contrastFixed)
    },
    pageLink() {
      let fhex = this.$store.getters.foreground.color.hex().substring(1)
      let bhex = this.$store.getters.background.color.hex().substring(1)
      return 'color.review/check/' + fhex + '-' + bhex
    },
    osFocus() {
      return this.$store.state.app.osFocus
    },
    pageLinkFull() {
      return 'https://' + this.pageLink
    }
  },
  methods: {
    hideApp() {
      window.webkit.messageHandlers.jsHandler.postMessage('hideApp');
    },
    closeApp() {
      window.webkit.messageHandlers.jsHandler.postMessage('closeApp');
    },
    breakApp() {
      this.$root.$el.parentNode.removeChild(this.$root.$el)
      window.demoBreak = true
    }
  }
};


</script>

<style lang="scss">
.app-has-focus {
  .contrast {
      background: rgba($color: white, $alpha: 1);
  }
}
.contrast {
  margin-top: 6px !important;
  margin-bottom: 8px;
  font-size: 13px;
  user-select: none;
  position: relative;
  display: flex;
  justify-content: flex-start;
  // background: yellow;
    background: #f6f6f6;

  // background: rgba($color: white, $alpha: 1);
  border-radius: 5px;
  padding: 6px 16px;
  padding-top: 7px;
    align-items: center;
  // margin-left: 40px;
  .contrast-left {
    // width: 200px;
    display: flex;
   align-items: center;

    .title {
      align-items: center;
      color: #000;
      font-size: 11px;
      // transform: translateY(3px);
    }
    .value {
      font-weight: 400;
      font-size: 20px;
      margin-left: 14px;
      user-select: all;
      width: 40px;
    }
  }

  .settings {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: -2px;
    img {
      // height: 200%;
    }

  }
  .contrast-right {
    display: flex;
    margin-left: 10px;
    .block {
      margin-left: 24px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .type {
        margin-right: 12px;
        display: flex;
        font-weight: 400;
        font-size: 11px;
        align-items: center;
              color: #000;

      }
      .aa-inline {
        width: 50px;
        text-align: left;
      }
      svg {
        transform: translateY(0.6px);
        user-select: none;
        pointer-events: none;
      }
    }
  }
  .page-link {
    width: 260px;
    // background: red;
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;
    padding-right: 14px;
    padding-left: 10px;
    box-sizing: border-box;
    color: #757474;
    font-size: 11px;
    letter-spacing: 0.02em;
    user-select: all;
    svg {
      margin-right: 6px;
      transform: translateY(0.6px);
    }
  }
}
</style>
